/* Superoom PDP tidying. Two jobs, both corrections to sections we do not own outright.

   ONE - reclaims the old main-product section. The offer module already owns the gallery, the title,
   the price and the buy button, so the only thing worth keeping from main is the long-form copy.
   This folds the description into a collapsed panel, moves it and the theme's accordions into the
   offer module's gallery column, then hides what is left of main. The hide is applied by JS, so if
   any of this fails the old section stays visible and nothing is lost.

   TWO - restyles the review carousel. See the note above reviewCards(). */
(function () {
  function singleOpen(scope) {
    if (!scope || scope.dataset.sroAccordion) return;
    scope.dataset.sroAccordion = '1';
    // The toggle event does not bubble, so listen in the capture phase.
    scope.addEventListener(
      'toggle',
      function (e) {
        var opened = e.target;
        if (!opened || opened.tagName !== 'DETAILS' || !opened.open) return;
        Array.prototype.slice.call(scope.querySelectorAll('details')).forEach(function (d) {
          if (d !== opened && d.open) {
            d.open = false;
            if (d.hasAttribute('aria-expanded')) d.setAttribute('aria-expanded', 'false');
          }
        });
      },
      true
    );
  }

  /* The equation's middle tile used to sit directly above a row of mini chips, so "Pick a 15ml mini"
     was an instruction with somewhere to obey it. The choice now lives in the cart drawer
     (superoom-cart-gift.js hides that chip row), which leaves this caption telling people to pick
     something with no picker in sight. Only the first text node is rewritten so the "9 nights" line
     underneath is untouched. */
  function fixEquationCaption() {
    var caps = document.querySelectorAll('.sro-eq__cap');
    Array.prototype.slice.call(caps).forEach(function (cap) {
      Array.prototype.slice.call(cap.childNodes).forEach(function (n) {
        if (n.nodeType !== 3) return;
        var t = n.nodeValue;
        if (t && t.indexOf('Pick a 15ml mini') !== -1) {
          n.nodeValue = t.replace('Pick a 15ml mini', 'A 15ml mini');
        }
      });
    });
  }

  /* ------------------------------------------------------------------------------------------
     REVIEW CAROUSEL: solid forest blocks -> tinted cards with a formula-accent hairline.

     THE PROBLEM WAS CONTRAST, not layout. The cards were solid #0B312C on a cream ground, the
     highest-contrast pairing in the palette. Four in a row and the eye reads shapes before words,
     and the darkest thing on the page ends up being the part that should feel like someone quietly
     telling you something. A review should look like a voice, not a billboard.

     A HAIRLINE, NOT A HEAVY OUTLINE. At 1px the card reads as a held space rather than a box. A
     thick border on this palette would only trade one hard block for another.

     PER FORMULA, WHICH IS THE EXISTING RULE. The brand system puts formula colour on "toggles, tiles
     and review accents" and keeps commerce UI deep green. So the tint, the edge and the stars follow
     the product, and the page still reads as one brand because the tints are barely there.

     IT ALSO SLOWED DOWN. The marquee ran an 8s loop, which is a reading speed nobody has: a quote
     crossed the viewport before it could be finished, so the section registered as decoration rather
     than evidence. 26s is a drift, and hovering stops it outright so a reader who wants one can
     have it.

     TWO IMPLEMENTATION NOTES. The block is AI-generated and its class names carry a random suffix
     (ai-testimonial-card-atzarcx...), so everything is matched on the stable prefix with [class*=]
     rather than the generated name, which would break the moment the block is regenerated. And the
     rules need !important: the block prints its own <style> inside <body>, which beats a stylesheet
     in <head> at equal specificity on source order alone. */
  var REVIEW_THEME = {
    reishi:    { tint: '#FBEFEF', edge: 'rgba(170,17,17,.22)',  accent: '#AA1111' },
    lionsmane: { tint: '#FAF3E8', edge: 'rgba(133,79,11,.24)',  accent: '#854F0B' },
    cordyceps: { tint: '#FAF0EB', edge: 'rgba(153,60,29,.24)',  accent: '#993C1D' },
    chaga:     { tint: '#EDF5F6', edge: 'rgba(13,104,120,.24)', accent: '#0D6878' }
  };
  /* Anything that is not one of the four formulas keeps a neutral card and the original gold stars,
     so a bundle or a new product never inherits somebody else's colour by accident. */
  var REVIEW_DEFAULT = { tint: '#F6F3E9', edge: 'rgba(11,49,44,.16)', accent: '#D4A017' };

  function formulaOnPage() {
    var h = document.querySelector('[data-sro-root] h1') || document.querySelector('h1');
    var t = h ? (h.textContent || '').toLowerCase().replace(/[^a-z]/g, '') : '';
    if (t.indexOf('reishi') !== -1) return 'reishi';
    if (t.indexOf('lionsmane') !== -1) return 'lionsmane';
    if (t.indexOf('cordyceps') !== -1) return 'cordyceps';
    if (t.indexOf('chaga') !== -1) return 'chaga';
    return null;
  }

  function reviewCards() {
    if (!document.querySelector('[class*="ai-testimonial-card-"]')) return;

    var f = formulaOnPage();
    var t = (f && REVIEW_THEME[f]) || REVIEW_DEFAULT;
    var root = document.documentElement;
    root.style.setProperty('--sr-rev-tint', t.tint);
    root.style.setProperty('--sr-rev-edge', t.edge);
    root.style.setProperty('--sr-rev-accent', t.accent);

    if (document.getElementById('sr-rev-style')) return;
    var s = document.createElement('style');
    s.id = 'sr-rev-style';
    s.textContent =
      '[class*="ai-testimonial-card-"]{' +
        'background:var(--sr-rev-tint,#F6F3E9)!important;' +
        'border:1px solid var(--sr-rev-edge,rgba(11,49,44,.16))!important;' +
        'box-shadow:none!important;' +
      '}' +
      '[class*="ai-testimonial-text-"],' +
      '[class*="ai-testimonial-text-"] p,' +
      '[class*="ai-testimonial-text-"] span{color:#2B3A34!important}' +
      '[class*="ai-testimonial-name-"]{color:#14211C!important}' +
      '[class*="ai-testimonial-title-"]{color:#7C877F!important}' +
      'svg[class*="ai-testimonial-star-"],' +
      'svg[class*="ai-testimonial-star-"] path{fill:var(--sr-rev-accent,#D4A017)!important}' +
      /* 8s was faster than anyone reads. */
      '[class*="ai-testimonial-carousel__track-"]{animation-duration:26s!important}' +
      '[class*="ai-testimonial-carousel-"]:hover [class*="ai-testimonial-carousel__track-"]{' +
        'animation-play-state:paused!important}' +
      '@media (prefers-reduced-motion: reduce){' +
        '[class*="ai-testimonial-carousel__track-"]{animation:none!important}}';
    document.head.appendChild(s);
  }

  function run() {
    fixEquationCaption();
    reviewCards();

    var main = document.querySelector('.shopify-section--main-product');
    var list = main && main.querySelector('.product-info__block-list');
    if (!main || !list || list.dataset.sroFolded) {
      singleOpen(document.querySelector('[data-sro-root] .sro-info'));
      return;
    }
    var buy = list.querySelector('[data-block-type="buy-buttons"]');
    if (!buy) return;

    var texts = [];
    var el = buy.nextElementSibling;
    while (el) {
      if (el.matches('[data-block-type="text"]')) texts.push(el);
      el = el.nextElementSibling;
    }

    var moved = [];

    if (texts.length) {
      // The longest text block is the product description; anything shorter is a trust line.
      var desc = texts.reduce(function (a, b) {
        return (b.textContent || '').length > (a.textContent || '').length ? b : a;
      });
      if ((desc.textContent || '').trim().length >= 200) {
        var details = document.createElement('details');
        details.className = 'sro-fold';
        var summary = document.createElement('summary');
        summary.textContent = document.documentElement.getAttribute('data-sro-fold-label') || 'About this formula';
        var body = document.createElement('div');
        body.className = 'sro-fold__body';
        desc.parentNode.insertBefore(details, desc);
        details.appendChild(summary);
        details.appendChild(body);
        body.appendChild(desc);
        desc.style.display = 'block';
        moved.push(details);
      }
    }

    var group = list.querySelector('.accordion-group');
    if (group) moved.push(group);

    var gallery = document.querySelector('[data-sro-root] .sro__gallery');
    if (gallery && moved.length) {
      var wrap = document.createElement('div');
      wrap.className = 'sro-info';
      moved.forEach(function (n) { wrap.appendChild(n); });
      var quotes = gallery.querySelector('.sro-quotes');
      if (quotes) gallery.insertBefore(wrap, quotes);
      else gallery.appendChild(wrap);
      gallery.classList.add('sro__gallery--has-info');
      main.classList.add('sro-main-emptied');
      singleOpen(wrap);
    }

    list.dataset.sroFolded = '1';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  /* The review block and the offer module both render from Liquid but boot their own JS; retry once
     for the case where this file wins the race. */
  window.setTimeout(run, 1200);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-sro-opt]')) setTimeout(fixEquationCaption, 60);
  });
})();
